import { reactive } from "@vue/composition-api";
import { apiEndpoint } from "@/configs/api/api-configs";

export default function inventoryPrivilegeCpcModel() {
  const inventoryExternalCodeImportList = reactive({
    api: apiEndpoint.bcrm_platform + "/Inventory/Import_List",
    method: "POST",
    payload: {
      Inventory_Id: 0,
      Privilege_Id: 0,
      Page: 1,
      Limit: 10,
      Filters: [],
      Ordering: [],
    },
  });

  const inventoryExternalCodeWithdrawList = reactive({
    api: apiEndpoint.bcrm_platform + "/Inventory/Withdraw_List",
    method: "POST",
    payload: {
      Inventory_Id: 0,
      Privilege_Id: 0,
      Page: 1,
      Limit: 10,
      Filters: [],
      Ordering: [],
    },
  });

  //import detail
  const inventoryExternalCodeImportDetail = reactive({
    api: apiEndpoint.bcrm_platform + "/Inventory/Import_Detail",
    method: "POST",
    payload: {
      Inventory_Id: 0, // router.curentRoute.params.invRef
      Privilege_Id: 0, // router.curentRoute.params.ref
      Import_Id: 0,
      Page: 1,
      Limit: 10,
      Filters: [],
      Ordering: [],
    },
  });


  //serial stock
  const inventoryExternalCodeSerialList = reactive({
    api: apiEndpoint.bcrm_platform + "/Inventory/Serial_List",
    method: "POST",
    payload: {
      Inventory_Id: 0, // router.curentRoute.params.invRef
      Privilege_Id: 0, // router.curentRoute.params.ref
      Import_Id: 0,
      Page: 1,
      Limit: 10,
      Filters: [],
      Ordering: [],
      IsVerified: false

    },
  });

  const inventoryExternalCodeApproved = reactive({
    api: apiEndpoint.bcrm_platform + "/import/approve",
    method: "POST",
    payload: {
      Import_Id: 0,
      Req_Identity_Id: 1
    },
  });

  const inventoryExternalCodeReject = reactive({
    api: apiEndpoint.bcrm_platform + "/import/reject",
    method: "POST",
    payload: {
      Import_Id: 0,
      Req_Identity_Id: 1
    },
  });

    //serial stock
    const inventoryExpiredSerialList = reactive({
      api: apiEndpoint.bcrm_platform + "/Inventory/ExpiredSerial_List",
      method: "POST",
      payload: {
        Inventory_Id: 0, // router.curentRoute.params.invRef
        Privilege_Id: 0, // router.curentRoute.params.ref
        Import_Id: 0,
        Page: 1,
        Limit: 10,
        Filters: [],
        Ordering: [],
      },
    });

  return {
    inventoryExternalCodeImportList,
    inventoryExternalCodeWithdrawList,
    inventoryExternalCodeImportDetail,
    inventoryExternalCodeSerialList,
    inventoryExternalCodeApproved,
    inventoryExternalCodeReject,
    inventoryExpiredSerialList
  };
}
